<app-modal-header class="border-b-2 border-theme-500">
  <div class="flex w-full bg-white">
    <div class="flex">
      <svg-icon class="w-10 text-theme-500" src="assets/icons/icon-gestor-avaliacoes.svg" alt="Materiais Didaticos">
      </svg-icon>
      <h1 class="ml-3 hidden text-sm font-semibold leading-tight text-gray-800 md:grid" translate>
        gestor-avaliacoes.cpb
        <br />
        <b class="text-lg text-black" translate>gestor-avaliacoes.prova</b>
      </h1>
    </div>

    <hr app-modal-divider />

    <div class="flex w-full items-center justify-between">
      <div class="mr-5 grid">
        <span class="text-lg font-semibold leading-tight text-gray-800" translate>
          gestor-avaliacoes.configuracoes-avaliacao
        </span>
        <div class="grid gap-2 md:flex">
          <div
            class="group/copy flex cursor-pointer"
            app-clipboard
            app-tooltip
            [tooltip]="'geral.copiar' | translate"
            [clipboard]="data?.assessment?.code | uppercase"
          >
            <span class="flex uppercase text-gray-500"> # {{ data?.assessment?.code }} | </span>
          </div>
          <span class="whitespace-pre-wrap uppercase text-gray-500"> {{ data?.assessment?.titulo }} </span>
        </div>
      </div>
    </div>
  </div>
</app-modal-header>
